import React from 'react';
import PropTypes from 'prop-types';
import { AutoCompleteField } from './index';

const TableCellMultiSelect = ({
    value,
    label,
    options,
    className,
    disabled,
    placeholder,
    error,
    containerClass,
    errorClassName,
    creatable,
    onChange,
    menuPlacement,
}) => {
    return (
        <td className={className}>
            <AutoCompleteField
                creatable={creatable}
                label={label}
                value={value}
                disabled={disabled}
                isMulti
                options={options}
                placeholder={placeholder}
                containerClass={containerClass}
                errorClassName={errorClassName}
                error={error}
                onChange={onChange}
                hideDropdown={options?.length === 0}
                menuPlacement={menuPlacement}
            />
        </td>
    );
};

TableCellMultiSelect.propTypes = {
    ...AutoCompleteField.propTypes,
    className: PropTypes.string,
};

export default TableCellMultiSelect;
